import React from "react";
import { useGetWeeklyDetails } from "../../Controllers/DashboardController";
import DoughnutChartSmall from "../DoughnutChartSmall";
import CircularSkeletonLoader from "../SkeletonLoaders/CircularSkeletonLoader";

const TotalScoresCard = () => {
  const { data, isLoading, isError } = useGetWeeklyDetails();
  const totalScores = data?.totalScores || null;

  if (isError) return null;

  return (
    <div className="col-md-12">
      <div className="journal-card metric-card" style={{ height: "100%" }}>
        <h3 className="h6 mb-3">Total Scores</h3>
        {isLoading ? (
          <div className="d-flex flex-wrap gap-3">
            <CircularSkeletonLoader size="72px" count={5} />
          </div>
        ) : (
          <div className="streaks-grid">
            {Object.keys(totalScores || {}).length > 0
              ? Object.entries(totalScores).map(([key, value]) => (
                  <div className="streak-item" key={key}>
                    <div className="streak-circle">
                      <DoughnutChartSmall
                        dataset={[
                          value.obtained,
                          value.total > 0 ? value.total - value.obtained : 1,
                        ]}
                      />
                      <span className="streak-value">{value.obtained}</span>
                    </div>
                    <div className="streak-label">
                      {key
                        .split("_")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(" ")}
                    </div>
                  </div>
                ))
              : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default TotalScoresCard;
